import { render, staticRenderFns } from "./MainDataGrid.vue?vue&type=template&id=5cc7f2ba&scoped=true&"
import script from "./MainDataGrid.vue?vue&type=script&lang=js&"
export * from "./MainDataGrid.vue?vue&type=script&lang=js&"
import style0 from "./MainDataGrid.vue?vue&type=style&index=0&id=5cc7f2ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc7f2ba",
  null
  
)

export default component.exports